import { btnStyle, controlStyle, floatButtonStyle } from './shared-styles-from-theme-fluent';
import type { CommonStylesPalette } from '../types.d';


export const modalContainerStyle = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .modal-container': {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 'auto',
    width: 940,
    background: palette.white,
    boxShadow: '-5px 10px 15px 0px #0000002D',
    '-webkit-box-shadow': '-5px 10px 15px 0px #0000002D',
    overflow: 'auto',
    zIndex: 1070,

    '&.image-edit-modal': {
      width: 'auto',
    },

    '& .modal-content': {
      height: 'auto',
      width: 'auto',
      boxShadow: 'none',
      padding: '22px 32px 16px 32px',

      '& .add-image-content, & .image-edit-content': {
        fontSize: 14,
        lineHeight: '20px',
        position: 'relative',

        '& .add-image-label, & .edit-image-title': {
          fontSize: 20,
          fontWeight: 600,
          lineHeight: '27px',
          marginBottom: 16,
        },

        '& .add-image-description': {
          marginBottom: 20,
          paddingBottom: 32,
          borderBottom: `1px solid ${palette.neutralSecondary}`,
        },

        '& .image-preview-crop-description': {
          fontSize: 14,
          lineHeight: '20px',
          margin: '0 0 32px 0',
        },

        '& .image-cropper-ratio-label': {
          fontSize: 14,
          fontWeight: 'normal',
          lineHeight: '20px',
          margin: '16px 0',
        },

        '& .close-dialog-button': {
          backgroundColor: 'transparent',
          color: palette.neutralSecondary,
          fontFamily: iconFontFamily,
          fontSize: 12,
          lineHeight: 1,
          position: 'absolute',
          right: 0,
          top: 0,
          border: 'none',
          background: 'none',

          '&:before': {
            content: '"\\E711"',
          },
        },

        '& .search-box-container': {
          width: '40%',

          '& .search-box__input-group': {
            display: 'flex',

            '& input.search-box__input': {
              color: palette.neutralSecondary,
              marginLeft: '-16px',
              padding: '6px 8px 6px 32px',
              order: 1,
            },

            '& .search-box__icon': {
              position: 'relative',
              top: 8,
              left: 8,
              fontFamily: iconFontFamily,
              fontSize: 16,
              lineHeight: 1,
              order: 0,

              '&:before': {
                content: '"\\E721"',
              },
            },
          },
        },

        '& .sort-by-label': {
          display: 'none',
        },

        '& .dropdown-selector-container': {
          float: 'right',
          minWidth: '25%',

          '& .dropdown-toggle': {
            background: 'url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM0ODQ2NDQ7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5BcnRib2FyZCAxPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMS4zNyw0bC41Mi41M0w2LDEwLjQ1LjEyLDQuNTYuNjQsNCw2LDkuNFoiLz48L3N2Zz4=") no-repeat right 8px top 8px transparent',
            backgroundSize: '14px 14px',
            borderColor: palette.neutralSecondary,
            borderRadius: 2,
            boxShadow: 'none',
            color: palette.neutralPrimary,
            fontWeight: 'normal',
            height: 32,
            padding: '0px 28px 0px 8px',
            transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out',
            width: '100%',
            '-webkit-box-shadow': 'none',
            '-webkit-appearance': 'none',
            '-moz-appearance': 'none',

            '&:active': {
              borderColor: palette.themePrimary,
            },

            '&:focus': {
              borderColor: palette.themePrimary,
              outline: 0,
            },

            '&:hover': {
              borderColor: palette.neutralPrimary,
            },

            '& span': {
              margin: 'auto 0',
            },

            '& .glyphicon-triangle-bottom': {
              display: 'none',
            },
          },
        },

        '& .image-picker': {
          background: 'none',
          border: 'none',
          margin: '16px 0',
          padding: 0,

          '& .existing-images': {
            display: 'flex',
            flexWrap: 'wrap',
            height: 'auto',
            justifyContent: 'space-between',

            '& .existing-image-container': {
              display: 'inline-flex',
              margin: '0 0 24px 0',
              paddingBottom: 20,

              '& .image-section-wrapper': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                height: 202,
                width: 202,

                '& .image-section': {
                  position: 'relative',

                  '& .image-dimensions': {
                    display: 'none',
                  },

                  '& button.existing-image': {
                    border: '1px solid transparent',

                    '&:before': {
                      fontFamily: iconFontFamily,
                      fontSize: 18,
                      position: 'absolute',
                      right: 5,
                      top: 5,
                    },

                    '& img': {
                      margin: 0,
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },

                  '&:active button.existing-image': {
                    border: `1px solid ${palette.themePrimary}`,

                    '&:before': {
                      color: palette.themePrimary,
                      content: '"\\ECCB"',
                    },
                  },

                  '&:focus button.existing-image': {
                    border: `1px solid ${palette.neutralSecondary}`,
                  },

                  '&:hover button.existing-image': {
                    border: `1px solid ${palette.neutralPrimary}`,

                    '&:before': {
                      color: palette.neutralPrimary,
                      content: '"\\ECCA"',
                    },
                  },

                  '& button.glyphicon-remove': {
                    extend: floatButtonStyle({ palette }).floatButton,
                    position: 'absolute',
                    top: 'unset',
                    right: 1,
                    bottom: 1,
                    fontFamily: iconFontFamily,
                    fontSize: 16,
                    lineHeight: 1,
                    float: 'right',

                    '&:before': {
                      content: '"\\E711"',
                    },
                  },
                },
              },

              '& .image-name-section': {
                bottom: 0,
                left: 0,
                position: 'absolute',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',

                '& .image-name': {
                  position: 'relative',
                  left: 0,
                  bottom: 0,
                  width: 'auto',
                },

                '& .glyphicon-pencil': {
                  background: 'none',
                  color: palette.themeDark,
                  display: 'inline',
                  fontFamily: iconFontFamily,
                  paddingLeft: 8,
                  position: 'relative',
                  top: 'unset',
                  right: 'unset',

                  '&:before': {
                    content: '"\\E70F"',
                  },
                },
              },

              '& .image-name-container': {
                background: palette.white,
                border: 'rgba(0, 0, 0, 0.2)',
                boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.2)',
                left: 0,
                margin: 1,
                padding: 16,
                width: 220,
                zIndex: 9,

                '& .image-name-input': {
                  extend: controlStyle({ palette })['.form-control'],

                  '& + button': {
                    extend: btnStyle({ palette })['.btn-primary'],
                  },
                },

                '& #image-name-field': {
                  width: '100%',
                },

                '& button': {
                  marginLeft: 0,
                  marginTop: 16,

                  '& ~ button': {
                    marginLeft: 8,
                  },
                },
              },

              '& .image-delete.glyphicon.glyphicon-remove': {
                display: 'inline',
              },
            },
          },
        },

        '& .ba-pagination': {
          display: 'block',
          textAlign: 'center',
        },

        '& .choose-file-description': {
          borderTop: `1px solid ${palette.neutralSecondary}`,
          paddingTop: 32,
        },

        '& .file-picker-react-wrapper': {
          margin: 0,
          padding: '14px 0 0 0',
          width: '100%',

          '& .file-picker-btn': {
            extend: btnStyle({ palette })['.btn-default'],
            display: 'inline-block',
            float: 'none',
            marginLeft: 0,

            '& ~ .file-text': {
              display: 'inline-block',
              border: 'none',
            },
          },
        },

        '& .add-image-button-bar, & .image-edit-actions': {
          borderTop: `1px solid ${palette.neutralSecondary}`,
          marginTop: 32,
          paddingTop: 16,

          '& button ~ button': {
            marginLeft: 12,
          },
        },

        '& .image-cropper-in-edit': {
          margin: 0,
          padding: 0,
        },

        '& .edit-preview-section': {
          display: 'flex',

          '& .edit-section': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        },
      },

      '& .preview-section': {
        border: '1px solid #C8C8C8',
        padding: '20px 24px',

        '& .preview-section-title': {
          fontSize: 18,
          fontWeight: 'normal',
          lineHeight: '24px',
        },
      },

      '& .HelpTopic': {
        verticalAlign: 'baseline',
      },
    },
  },
});
